<template>
  <el-scrollbar v-loading="loading" class="set-authority">
    <permission-info :data="businessData" />
  </el-scrollbar>
</template>

<script setup lang="ts">
import { PermissionInfo, queryBusinessAgentSelf } from '@core/main';
import { IBusinessAuthInfo } from '@core/main/types';
import { ElMessage } from 'element-plus';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

defineOptions({ name: 'SetAuthorityTab' }); // 账户中心 - 企业管理详情 - 设置权限

const route = useRoute();

const businessData = ref<IBusinessAuthInfo[]>();
const loading = ref(false);

const curCompanyId = computed(() => route.query && Number(route.query.id) as number);

async function fetchData() {
  loading.value = true;
  try {
    businessData.value = await queryBusinessAgentSelf(curCompanyId.value, false);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  loading.value = false;
}

fetchData();

</script>

<style lang="scss" scoped>
.set-authority {
  @apply h-[calc(100%-76px)] rounded-[2px] p-6 pr-[0] pb-[0] bg-white;
}
</style>
